import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';

import { getEvents, getAnnouncements, getBlogs } from '../services/api';
// sortEventsByDateDesc import removed

const NewsPage = ({ type = 'events' }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const isAnnouncements = type === 'announcements';
    const isBlogs = type === 'blogs';

    let title = "Haberler & Etkinlikler";
    let description = "Topluluğumuzdan en güncel haberler ve etkinlik detayları.";

    if (isAnnouncements) {
        title = "Duyurular";
        description = "Önemli duyurular ve yaklaşan etkinlik bilgileri.";
    } else if (isBlogs) {
        title = "Köşe Yazıları";
        description = "Üyelerimizin kaleminden deneyimler ve gezi notları.";
    }
    useEffect(() => {
        window.scrollTo(0, 0);

        const fetchData = async () => {
            setLoading(true);
            try {
                let result = [];
                if (isAnnouncements) result = await getAnnouncements();
                else if (isBlogs) result = await getBlogs();
                else result = await getEvents();

                // Forced sort removed. We rely on API order now.

                setData(result);
            } catch (error) {
                console.error("Veri çekilemedi:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [type, isAnnouncements, isBlogs]);

    if (loading) {
        return (
            <div className="bg-modern-blue-50 text-modern-blue-900 min-h-screen flex items-center justify-center">
                <div className="text-xl font-bold text-cyan-600">Yükleniyor...</div>
            </div>
        );
    }

    return (
        <div className="bg-modern-blue-50 text-modern-blue-900 min-h-screen">
            <main className="pt-32 pb-20 px-6">
                <div className="container mx-auto">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="text-center mb-16"
                    >
                        <h1 className="text-3xl md:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-modern-blue-900 via-modern-blue-600 to-emerald-500 mb-6 drop-shadow-sm">
                            {title}
                        </h1>
                        <p className="text-modern-blue-600 max-w-2xl mx-auto text-base leading-relaxed">
                            {description}
                        </p>
                    </motion.div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {data.map((item, index) => (
                            <motion.div
                                key={item.id}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.1 }}
                                className="bg-white rounded-3xl overflow-hidden shadow-lg border border-modern-blue-100 hover:border-cyan-400 transition-all flex flex-col group"
                            >
                                {/* Image (Only for Events/News) */}
                                {!isAnnouncements && item.image && (
                                    <div className="h-auto md:h-64 overflow-hidden relative">
                                        <img
                                            src={item.image}
                                            alt={item.title}
                                            className="w-full h-auto md:h-full object-contain md:object-cover bg-gray-50 transition-transform duration-700 group-hover:scale-110"
                                        />
                                        <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-md px-3 py-1 rounded-full text-xs font-bold text-modern-blue-900 shadow-sm">
                                            {item.date}
                                        </div>
                                    </div>
                                )}

                                {/* Card Content */}
                                <div className="p-8 flex-1 flex flex-col">
                                    {isAnnouncements && (
                                        <div className="flex items-center gap-2 text-yellow-600 text-sm font-bold mb-4 bg-yellow-50 w-fit px-3 py-1 rounded-full">
                                            <Calendar className="w-4 h-4" />
                                            {item.date}
                                        </div>
                                    )}

                                    {isBlogs && (
                                        <div className="mb-4">
                                            <div className="text-gray-900 font-bold text-base leading-tight">
                                                {item.author}
                                            </div>
                                            {item.authorRole && (
                                                <div className="text-xs text-gray-500 italic mt-1">
                                                    {item.authorRole}
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    <h3 className="text-lg font-bold text-modern-blue-950 mb-3 leading-tight group-hover:text-cyan-600 transition-colors">
                                        {item.title}
                                    </h3>

                                    <p className="text-gray-500 text-xs mb-6 line-clamp-3 leading-relaxed flex-1">
                                        {item.summary || (item.content ? item.content.replace(/<[^>]+>/g, '').substring(0, 100) + '...' : '')}
                                    </p>

                                    <Link
                                        to={isAnnouncements ? `/duyurular/${item.id}` : (isBlogs ? `/kose-yazilari/${item.id}` : `/haberler/${item.id}`)}
                                        className="inline-flex items-center gap-2 text-cyan-600 font-bold text-xs group/link"
                                    >
                                        Detayları İncele
                                        <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" />
                                    </Link>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </main>
        </div>
    );
};

export default NewsPage;

